import { createAtomObserver } from '@exodus/atoms';
const ordersLifecyclePlugin = ({ orders, port, ordersAtom, ordersMonitor, }) => {
    const atomObserver = createAtomObserver({ atom: ordersAtom, port, event: 'orders' });
    const onStart = () => {
        orders.start();
        ordersMonitor.start();
    };
    const onLoad = async () => {
        void atomObserver.start();
    };
    const onUnlock = async () => {
        await orders.load();
        ordersMonitor.tick();
    };
    const onClear = () => orders.clear();
    const onStop = () => orders.stop();
    return { onClear, onLoad, onStart, onStop, onUnlock };
};
const ordersLifecyclePluginDefinition = {
    id: 'ordersLifecyclePlugin',
    type: 'plugin',
    factory: ordersLifecyclePlugin,
    dependencies: ['orders', 'port', 'ordersAtom', 'ordersMonitor'],
    public: true,
};
export default ordersLifecyclePluginDefinition;
